import Axios from "axios";
import { siteUrl, version } from "../constants/constants";
import cookie from "js-cookie";
import { message } from "antd";

const queryString = require("query-string");
let parsed = queryString.parse(window.location.search);

const instanceSber = Axios.create({
  baseURL: siteUrl + "/apisbersc/",
});

instanceSber.interceptors.request.use(
  (config) => {
    let token = cookie.get("token");
    if (parsed.token) token = parsed.token;

    if (token) {
      config.timeout = 3600000;
      config.headers["Authorization"] = "Bearer " + token;
      config.headers["Version"] = version;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export const apiSber = {
  checkSberStatus(numberOrder: string) {
    return instanceSber
      .post("get-status", {
        order_number: numberOrder,
      })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  setCreateBeneficiarsOrg(data: any) {
    return instanceSber
      .post("Beneficiary/createOrg", data)
      .then((res) => res.data)
      .catch((err) => {
        if (err.response.data && err.response.data.moreInformation)
          message.error(err.response.data.moreInformation);
        else if (err.response.data)
          message.error(JSON.stringify(err.response.data));
        else message.error("Произошла ошибка");
        return undefined;
      });
  },

  setCreateBeneficiarsIp(data: any) {
    return instanceSber
      .post("Beneficiary/createIp", data)
      .then((res) => res.data)
      .catch((err) => {
        if (err.response.data && err.response.data.moreInformation)
          message.error(err.response.data.moreInformation);
        else if (err.response.data)
          message.error(JSON.stringify(err.response.data));
        else message.error("Произошла ошибка");
        return undefined;
      });
  },

  createSmartContract(
    beneficiaryId: string,
    numberOrder: number,
    total_price: number,
    supplier_code: string,
    shop: string,
  ) {
    return instanceSber
      .post("SmartContract/create", {
        supplierCode: supplier_code,
        shop: shop,
        num: numberOrder,
        amount: total_price,
        beneficiaryId: beneficiaryId,
      })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getBeneficiaryInfo(
    beneficiaryId: string,
    pageNumber: number,
    pageSize: number,
  ) {
    return instanceSber
      .get(
        "get-beneficiary/" +
          beneficiaryId +
          "?pageNumber=" +
          pageNumber +
          "&pageSize=" +
          pageSize,
      )
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getBeneficiaryState(
    beneficiaryId: string,
    eventsPageNum: number,
    eventsPageSize: number,
    contractsPageNum: number,
    contractsPageSize: number,
  ) {
    return instanceSber
      .get(
        "Beneficiary/" +
          beneficiaryId +
          "/state" +
          "?eventsPageNum=" +
          eventsPageNum +
          "&eventsPageSize=" +
          eventsPageSize +
          "&contractsPageNum=" +
          contractsPageNum +
          "&contractsPageSize=" +
          contractsPageSize,
      )
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getBeneficiaryByInn(inn: string) {
    return instanceSber
      .get("Beneficiary/getBy?inn=" + inn)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getBeneficiaryByCodeCustomer(supplier: string, codeSupplier: string) {
    return instanceSber
      .get(
        "Beneficiary/getBy?supplier=" +
          supplier +
          "&codeSupplier=" +
          codeSupplier,
      )
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  // Реестр бенефициаров (для админа): pageNumber с 0, pageSize от 1 до 40
  getBeneficiaryRegistryList(pageNumber: number, pageSize: number) {
    return instanceSber
      .get(
        "Beneficiary/registry/list?pageNumber=" +
          pageNumber +
          "&pageSize=" +
          pageSize,
      )
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  // Состояние бенефициара для реестра (для админа):
  // баланс + постранично события и смарт-контракты
  getBeneficiaryStateRegistry(
    beneficiaryId: string,
    eventsPageNumber: number = 0,
    eventsPageSize: number = 20,
    smartContractsPageNumber: number = 0,
    smartContractsPageSize: number = 20,
  ) {
    return instanceSber
      .get(
        "Beneficiary/" +
          beneficiaryId +
          "/state?eventsPageNumber=" +
          eventsPageNumber +
          "&eventsPageSize=" +
          eventsPageSize +
          "&smartContractsPageNumber=" +
          smartContractsPageNumber +
          "&smartContractsPageSize=" +
          smartContractsPageSize,
      )
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  // Список заявок с оплатой (для админа): pageNumber с 0, pageSize от 1 до 100
  getOrderPaymentsList(pageNumber: number, pageSize: number) {
    return instanceSber
      .get(
        "order-payments?pageNumber=" +
          pageNumber +
          "&pageSize=" +
          pageSize,
      )
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  // Информация об оплате контракта (для админа):
  // summary + timeline + historyWarning
  getOrderPaymentInfo(contractId: string) {
    return instanceSber
      .get("order-payments/" + contractId)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getBeneficiaryAccessByUser(beneficiaryId: string) {
    return instanceSber
      .get("Beneficiary/" + beneficiaryId + "/payUsers")
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  addBeneficiaryAccessByUser(login: string, beneficiaryId: string) {
    return instanceSber
      .post("Beneficiary/payUser", {
        login: login,
        beneficiaryId: beneficiaryId,
      })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  delBeneficiaryAccessByUser(code: string) {
    return instanceSber
      .delete("/Beneficiary/payUser/" + code)
      .then((res) => res.data)
      .catch((err: any) => {
        if (err?.response?.data?.message)
          message.error(err.response.data.message);
        else message.error("Произошла ошибка");
        return undefined;
      });
  },

  getUrlByMomentPaySber(code: string, amount: number) {
    return instanceSber
      .post("InstantPay/fromInvoiceAny", {
        amount: amount,
        auth_code: code,
        type: "Payment",
      })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getPaymentOrderQr(beneficiaryCode: string, amount: number) {
    return instanceSber
      .get(
        siteUrl +
          "/apisber/beneficiary/" +
          beneficiaryCode +
          "/credit/payment-order-qr?amount=" +
          amount,
        { responseType: "blob", headers: { Accept: "image/png" } },
      )
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  backMoneyBeneficiary(beneficiaryId: string, amount: number) {
    return instanceSber
      .post("Beneficiary/takeBackMoney", {
        amount: amount,
        beneficiaryId: beneficiaryId,
      })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getDictionarySber(table: string) {
    return instanceSber
      .get("dictionaries/" + table)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },
};
